import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].GET_DONE_WORKS_OPERATIONAL_MATERIALS]: {
		url:'/company/:companyId/done_works/:doneWorkId/operational_materials/'
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].GET_DONE_WORKS_OPERATIONAL_MATERIAL_PREVIEW]: {
		url: '/company/:companyId/done_works/:doneWorkId/operational_materials/:operationalMaterialId/preview/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].GET_DONE_WORKS_OPERATIONAL_MATERIAL_POPUP]: {
		url: '/company/:companyId/done_works/:doneWorkId/operational_materials/:operationalMaterialId/popup/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].GET_DONE_WORKS_OPERATIONAL_MATERIAL]: {
		url: '/company/:companyId/done_works/:doneWorkId/operational_materials/:operationalMaterialId/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].CREATE_DONE_WORKS_OPERATIONAL_MATERIAL]: {
		url:'/company/:companyId/done_works/:doneWorkId/operational_materials/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].PATCH_DONE_WORKS_OPERATIONAL_MATERIAL]: {
		url: '/company/:companyId/done_works/:doneWorkId/operational_materials/:operationalMaterialId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].PUT_DONE_WORKS_OPERATIONAL_MATERIAL]: {
		url: '/company/:companyId/done_works/:doneWorkId/operational_materials/:operationalMaterialId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].DELETE_DONE_WORKS_OPERATIONAL_MATERIAL]: {
		url: '/company/:companyId/done_works/:doneWorkId/operational_materials/:operationalMaterialId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}